import cn from 'classnames'
import * as React from 'react'

import styles from './hamburger.module.scss'

interface IHamburgerProps {
  active?: boolean
  theme?: 'paid' | 'free'
}

export default function Hamburger({
  active = false,
  className,
  theme = 'paid',
  ...rest
}: IHamburgerProps & React.ButtonHTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn([styles.root, styles.slider, active && styles.active, theme === 'free' && styles.free, className])}
      {...rest}
    >
      <div className={styles.box}>
        <div className={styles.inner} />
      </div>
    </div>
  )
}
